import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, FileText } from "lucide-react";

function LegalLayout({ title, note, paragraphs, testid }) {
  const navigate = useNavigate();
  return (
    <div className="anima-backdrop min-h-screen w-full flex justify-center">
      <div className="w-full max-w-md px-7 py-10" data-testid={testid}>
        <button onClick={() => navigate(-1)} className="text-anima-muted mb-6 flex items-center gap-1 text-sm" data-testid="legal-back">
          <ArrowLeft size={16} /> {note.back}
        </button>
        <div className="flex items-center gap-2 mb-2 text-anima-golddeep">
          <FileText size={18} />
          <span className="text-[11px] uppercase tracking-widest">{note.draft}</span>
        </div>
        <h1 className="font-serif text-4xl text-anima-ink mb-6">{title}</h1>
        <div className="space-y-4 text-[15px] text-anima-ink/90 leading-relaxed pb-10">
          {paragraphs.map((p, i) => (
            <p key={i} dangerouslySetInnerHTML={{ __html: p }} />
          ))}
        </div>
      </div>
    </div>
  );
}

export function Terms() {
  const { t } = useTranslation();
  return (
    <LegalLayout
      testid="legal-terms"
      title={t("legal.termsTitle")}
      note={{ back: t("common.back"), draft: t("legal.draftNote") }}
      paragraphs={t("legal.terms", { returnObjects: true })}
    />
  );
}

export function Privacy() {
  const { t } = useTranslation();
  return (
    <LegalLayout
      testid="legal-privacy"
      title={t("legal.privacyTitle")}
      note={{ back: t("common.back"), draft: t("legal.draftNote") }}
      paragraphs={t("legal.privacy", { returnObjects: true })}
    />
  );
}
